import { Star, Quote, Shield } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { CityData } from "@/utils/cityData";
import StructuredData from "@/components/StructuredData";
interface CityTestimonialsProps {
  city: CityData;
}
const CityTestimonials = ({
  city
}: CityTestimonialsProps) => {
  const testimonials = [{
    name: `Dr. med. Sarah Müller`,
    practice: `Hausarztpraxis ${city.name}`,
    text: `Nach einem Ransomware-Angriff war unsere Praxis 3 Tage lahmgelegt. Dank der Cyberversicherung wurden alle Kosten übernommen und wir hatten innerhalb von 24h IT-Forensik-Experten vor Ort. Absolute Empfehlung!`,
    rating: 5
  }, {
    name: `Dr. Michael Weber`,
    practice: `MVZ ${city.name}-Zentrum`,
    text: `Die Beratung war top - unser Tarif wurde perfekt auf unser MVZ mit 4 Standorten zugeschnitten. Die Prämie ist fair und das Sicherheitsgefühl unbezahlbar.`,
    rating: 5
  }].slice(0, 2);

  // Review Schema für jedes Testimonial (as generic Record)
  const reviewSchema: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": testimonials.map((testimonial, index) => ({
      "@type": "Review",
      "position": index + 1,
      "author": {
        "@type": "Person",
        "name": testimonial.name
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": testimonial.rating,
        "bestRating": 5,
        "worstRating": 1
      },
      "reviewBody": testimonial.text,
      "itemReviewed": {
        "@type": "Service",
        "name": `Cyberversicherung ${city.name}`
      }
    }))
  };
  return <>
      <StructuredData data={reviewSchema} />
    <section className="py-8 sm:py-12 lg:py-16">
      <div className="container mx-auto px-3 sm:px-4 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center mb-3 sm:mb-4">
            Das sagen Ärzte aus {city.name}
          </h2>
          <p className="text-sm sm:text-base text-center text-muted-foreground mb-6 sm:mb-8 lg:mb-10">
            Erfahrungen von Praxen, die bereits geschützt sind
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
            {testimonials.map((testimonial, index) => <div key={index} className="premium-card p-4 sm:p-6">
                <div className="flex items-start justify-between mb-3 sm:mb-4">
                  
                  <div className="flex items-center gap-1 px-2.5 sm:px-3 py-1.5 bg-accent/20 border border-accent/40 rounded-full">
                    <Shield className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-accent" />
                    <span className="text-xs text-accent font-bold">Verifiziert</span>
                  </div>
                </div>
                
                <div className="flex items-center gap-1 mb-3 sm:mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-accent text-accent" />)}
                </div>
                
                <p className="text-sm sm:text-base premium-card-description mb-4 line-clamp-4">
                  "{testimonial.text}"
                </p>
                
                <div className="border-t border-accent/20 pt-4 mt-auto">
                  <p className="font-semibold text-foreground text-sm">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {testimonial.practice}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="mt-6 sm:mt-8 lg:mt-10 text-center">
            <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/30 rounded-lg px-3 sm:px-4 py-2.5 sm:py-3">
              <Star className="w-4 h-4 sm:w-5 sm:h-5 fill-accent text-accent" />
              <span className="text-xs sm:text-sm lg:text-base font-semibold text-foreground">
                Bereits über 120 Praxen in {city.name} vertrauen uns
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>;
};
export default CityTestimonials;